export default __webpack_public_path__ + "static/stonesee-c23a5bd56dbd37454fa7f0bbfdd6c0e1.png";